export const TOKEN_TYPE = 'Bearer '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
export const API_BASE = 'https://dmkeith.directaffinitycx.net/api'
export const AUTH_API_KEY='141559e1-02f1-4767-a8de-627dddc07a66'